<input ngx-gp-autocomplete [options]="options" (onAddressChange)="AddressChange($event)" class="form-control" #placesRef="ngx-places"/>